__turbopack_context__.v({
  "cta": "HeroInfoCard-module-scss-module__nxF19G__cta",
  "description": "HeroInfoCard-module-scss-module__nxF19G__description",
  "infoCard": "HeroInfoCard-module-scss-module__nxF19G__infoCard",
});
